<template>
  <div class="box px-5 pt-5">
    <div class="flex flex-col lg:flex-row pb-5 -mx-5">
      <div class="flex flex-1 px-5 items-center justify-center lg:justify-start">
        <div class="w-20 h-20 sm:w-24 sm:h-24 flex-none image-fit relative">
          <div
            class="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-gray-200 dark:bg-dark-5 rounded-full"
          >
            <ImageIcon />
          </div>
        </div>
        <div class="ml-5">
          <div class="text-gray-700">
            {{ loan.user ? loan.user.lastName : '' }}
          </div>
          <div class="font-medium text-lg">
            <router-link
              :to="{ name: 'CustomerDetails', params: { customerId: loan.user.id } }"
              class="flex items-center"
            >
              {{ loan.user ? loan.user.firstName : '' }}
              <EyeIcon class="w-5 h-5 ml-3" />
            </router-link>
          </div>
          <div class="text-gray-700 mt-2">
            {{ loan.user ? loan.user.registrationNumber : '' }}
          </div>
          <div class="text-gray-700">
            {{ loan.user ? loan.user.phone : '' }}
          </div>
        </div>
      </div>
      <div
        class="mt-6 lg:mt-0 flex-1 flex flex-col items-center lg:items-end justify-center px-5 border-t lg:border-0 border-gray-200 dark:border-dark-5 pt-5 lg:pt-0"
      >
        <div v-if="loan.firstOfficer" class="truncate sm:whitespace-normal flex items-center">
          <strong class="mr-2">{{ $t('text.checkedBy') }}:</strong>
          {{ loan.firstOfficer.firstName }}
        </div>
        <div v-if="loan.officer" class="truncate sm:whitespace-normal flex items-center mt-1">
          <strong class="mr-2">{{ $t('text.confirmedBy') }}:</strong>
          {{ loan.officer.firstName }}
        </div>
        <!-- <div class="truncate sm:whitespace-normal flex items-center mt-1">
          <strong class="mr-2">{{ $t('text.contractedAt') }}:</strong>
          2021-01-01
        </div> -->
        <Button class="mt-4 border text-gray-700 dark:bg-dark-5 dark:text-gray-300">{{
          $t('text.seniorNotes')
        }}</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/button/Button';

export default {
  props: {
    loan: Object,
  },
  components: {
    Button,
  },
};
</script>
